// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"LoginForm_pageTitle__2zh2X","inputAreaWrapper":"LoginForm_inputAreaWrapper__2jYJR","errorBillboard":"LoginForm_errorBillboard__1yR1B"};